module.exports = __webpack_public_path__ + "media/images/athletes/2835-593189363e8665d2818b558e591d44e2.png";